import * as React from "react"
import { cn } from "../../lib/utils"

interface SegmentedSwitchProps {
  options: Array<{
    value: string
    label: string
    icon?: React.ReactNode
  }>
  value: string
  onValueChange: (value: string) => void
  className?: string
}

export function SegmentedSwitch({ options, value, onValueChange, className }: SegmentedSwitchProps) {
  return (
    <div className={cn("inline-flex rounded-lg border bg-background p-1", className)}>
      {options.map((option, index) => (
        <button
          key={option.value}
          onClick={() => onValueChange(option.value)}
          className={cn(
            "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-all",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
            "disabled:pointer-events-none disabled:opacity-50",
            value === option.value
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted-foreground hover:bg-muted hover:text-foreground",
            index === 0 && "rounded-r-none",
            index === options.length - 1 && "rounded-l-none",
            index > 0 && index < options.length - 1 && "rounded-none"
          )}
        >
          {option.icon && <span className="mr-2">{option.icon}</span>}
          {option.label}
        </button>
      ))}
    </div>
  )
} 